import { usePermissions } from "@Context/common/permissions/permissions";
import { FormControlLabel, FormControlLabelProps, Switch, SwitchProps, Typography, styled } from '@mui/material';

const BybSwitch_ = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    color: theme.palette.dsBase.v200,
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.dsPrimary.v300,
        opacity: 1,
        borderColor: theme.palette.dsPrimary.v300,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        backgroundColor: theme.palette.dsPrimary.v200,
        borderColor: theme.palette.dsPrimary.v200,
      },
      '& .MuiSwitch-thumb': {
        borderColor: theme.palette.dsPrimary.v300,
        backgroundColor: theme.palette.mode === 'light' ? theme.palette.dsBase.v100 : theme.palette.dsBase.v200,
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        borderColor: theme.palette.dsPrimary.v200,
        backgroundColor: theme.palette.dsPrimary.v100,
      },
    },
    '&.Mui-focusVisible + .MuiSwitch-track': {
      borderColor: theme.palette.dsBase.v200,
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      backgroundColor: theme.palette.dsNeutral.v100,
      borderColor: theme.palette.dsSurface.v100,
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      backgroundColor: theme.palette.dsSurface.v100,
      borderColor: theme.palette.dsSurface.v100,
      opacity: 1,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    border: '3px solid',
    borderColor: theme.palette.dsSurface.v300,
    backgroundColor: theme.palette.dsNeutral.v300,
    width: 22,
    height: 22,
    boxShadow: 'none',
    transition: theme.transitions.create(['border-color'], {
      duration: 500,
    }),
  },
  '& .MuiSwitch-track': {
    boxSizing: 'border-box',
    border: '2px solid',
    borderColor: theme.palette.dsSurface.v300,
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.dsSurface.v300,
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border-color'], {
      duration: 500,
    }),
  },
}));

export type BybSwitchFormControlLabelProps = Omit<FormControlLabelProps, 'control' | 'label'>;

export interface IBybSwitch extends SwitchProps {
  label?: string | React.ReactNode;
  formControlLabelProps?: BybSwitchFormControlLabelProps;
}

const BybSwitch = ({ label, formControlLabelProps, ...props }: IBybSwitch) => {
  const permissions = usePermissions?.();
  const isDisabled = permissions?.canEdit === false || !!props.disabled;

  return (
    <FormControlLabel
      label={
        typeof label === 'string' ? (
          <Typography variant="text1xl500" color="dsBase.v200">
            {label}
          </Typography>
        ) : (
          label
        )
      }
      control={<BybSwitch_ disabled={isDisabled} sx={{ m: 1 }} {...props} />}
      sx={{
        color: 'dsBase.v200',
      }}
      {...formControlLabelProps}
    />
  );
};

export default BybSwitch;
